export const APIs = {
  AW: {},
  RBA: {
    Geolocation: {
      Endpoint: `${process.env.EW_ENTERPRISE_API_URL}/api/experience/rba/website/geolocation/v1/getgeolocation`,
      Cookie: 'affiliategeolocationdata',
    },
  },
  Enterprise: {},
};
